var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-0 text-muted text-center fs-80"},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v(" Caricamento in corso...")])}]

export { render, staticRenderFns }